import { IKnmForm } from '../../../KnmPackage/MainModule/interfaces/IKnmForm';

export function requiredRequirementsErknmOrApproveDocsOrLinks(values: never, allValues: IKnmForm): string | undefined {
  const { requirementsErknm, requirementsNpaErknm, approveDocs, links, docTarget } = allValues;

  if (
    !requirementsErknm?.length &&
    !requirementsNpaErknm?.length &&
    !approveDocs?.length &&
    !links?.length &&
    !docTarget?.length
  ) {
    return 'Поле не может быть пустым';
  }
}
